import { Globals } from '@theme/utils/globals';
import { Component, HostListener, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Folder } from '@model/folder';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FolderService } from '@service/folder/folder.service';
import { Customer } from '@model/customer';
import { CustomerService } from '@service/customer/customer.service';
import { HouseService } from '@service/house/house.service';
import { HomeService } from '@service/home/home.service';
import { LotService } from '@service/lot/lot.service';
import { House } from '@model/house';
import { ValidatorsEnums } from '@theme/enums/validators.enums';
import { EmitterService } from '@service/emitter/emitter.service';
import { DateHelperService } from '@theme/utils/date-helper.service';
import { ToastrService } from 'ngx-toastr';
import { User } from '@model/user';
import { UserService } from '@service/user/user.service';
import { UploaderService } from '@service/uploader/uploader.service';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { Promotion } from '@model/promotion';
import { PromotionService } from '@service/promotion/promotion.service';
import { Home } from '@model/home';

@Component({
  selector: 'app-folder-add',
  templateUrl: './folder-add.component.html',
  styleUrls: ['./folder-add.component.scss']
})
export class FolderAddComponent implements OnInit {

  ESCAPE_KEYCODE = 27;
  title: string = ""
  edit: boolean = false
  editLocked: boolean = false
  folder: Folder
  houses: House[] = []
  homes: Home[] = []
  promotions: Promotion[] = [];
  sousPromotions: Promotion[] = [];
  motifRow = [
    { label: "Acquisition auprès d'un bailleur", value: 'PROPRIETAIRE' },
    { label: 'Projet de lotissement', value: 'LOT' },
    { label: 'Promotion immobilière', value: 'MAISON' },
  ]
  advanceRow = [
    { label: "Réservation", prc: 10 },
    { label: 'Fin de modalité', prc: 10 },
    { label: 'Gros oeuvre', prc: 40 },
    { label: 'Finition', prc: 30 },
    { label: 'Reception définitive', prc: 10 },
  ];
  booleanRow = [
    { label: 'Non', value: false },
    { label: 'Oui', value: true }
  ];
  form: FormGroup
  submit: boolean = false
  customers: Customer[]
  customer: Customer
  house: House;
  nbrMois: number = 0
  required = Globals.required
  totalRemise: number = 0;
  totalHt: number = 0;
  totalTtc: number = 0;
  totalTva: number = 0;
  total: number = 0;
  taux: number = 0;
  users: User[];
  customerSelected: any
  houseSelected: any
  homeSelected: any
  lotSelected: any
  selectedPromotion: any
  selectedSousPromotion: any

  // Propriétés pour l'amortissement
  tableauAmortissement: any[] = [];
  mensualiteConstante: number = 0;

  // Propriétés pour l'échéancier progressif
  tableauProgressif: any[] = [];
  loyerProgressifInitial: number = 0;

  constructor(
    public modal: NgbActiveModal,
    private formBuild: FormBuilder,
    public uploadService: UploaderService,
    private folderService: FolderService,
    private customerService: CustomerService,
    private houseService: HouseService,
    private lotService: LotService,
    private homeService: HomeService,
    public userService: UserService,
    private emitter: EmitterService,
    public toastr: ToastrService,
    public promotionService: PromotionService
  ) {
    this.edit = this.folderService.edit;
    this.folder = this.folderService.getFolder();
    this.editLocked = false;
    this.newForm();
    if (this.edit && this.folder.motif == "MAISON") {
      this.promotionService.getListLight().subscribe((res) => {
        this.promotions = res;
      })
    }
    this.userService.getList('COMMERCIAL', null).subscribe(res => { this.users = res ? res : []; }, error => { });
  }

  ngOnInit(): void {
    this.editForm();
    this.title = !this.edit ? 'Ajouter un nouveau dossier' : 'Modifier le dossier du client ' + this.folder?.customer?.nom;
  }

  calculerMensualiteAmortissement(capital: number, tauxAnnuel: number, dureeMois: number): number {
    console.log('=== DEBUG MENSUALITÉ ===');
    console.log('Capital:', capital);
    console.log('Taux annuel:', tauxAnnuel);
    console.log('Durée:', dureeMois);

    if (capital <= 0 || tauxAnnuel <= 0 || dureeMois <= 0) return 0;

    const tauxMensuel = tauxAnnuel / 12;
    const mensualite = capital * tauxMensuel / (1 - Math.pow(1 + tauxMensuel, -dureeMois));

    console.log('Taux mensuel:', tauxMensuel);
    console.log('Mensualité brute:', mensualite);

    const resultat = Math.round(mensualite / 1000) * 1000;
    console.log('Mensualité arrondie:', resultat);

    return resultat;
  }

  genererTableauAmortissement(capital: number, tauxAnnuel: number, dureeMois: number) {
    this.tableauAmortissement = [];

    if (capital <= 0 || dureeMois <= 0) return;

    const mensualiteBase = this.calculerMensualiteAmortissement(capital, tauxAnnuel, dureeMois);

    const debit = capital / dureeMois;
    let capitalRestant = capital;
    let cumulPaiements = 0;

    for (let periode = 1; periode <= dureeMois; periode++) {
      const capitalRestantAvantPaiement = capitalRestant;

      const tauxMensuel = tauxAnnuel / 12;
      const interets = capitalRestantAvantPaiement * tauxMensuel;

      const capitalRembourse = debit;

      capitalRestant = capitalRestant - debit;
      cumulPaiements += mensualiteBase;

      console.log(`Période ${periode}:`, {
        capitalAvant: capitalRestantAvantPaiement,
        debit: debit,
        capitalApres: capitalRestant,
        interets: interets,
        mensualiteBase: mensualiteBase
      });

      this.tableauAmortissement.push({
        periode: periode,
        mensualite: mensualiteBase,
        interets: Math.round(interets),
        capitalRembourse: Math.round(capitalRembourse),
        capitalRestant: Math.max(0, Math.round(capitalRestant)),
        cumulPaiements: Math.round(cumulPaiements),
        debit: Math.round(debit)
      });
    }

    console.log('Tableau d\'amortissement généré:', this.tableauAmortissement);
  }

  /**
   * Calcule le loyer progressif initial L tel que la valeur actuelle
   * de tous les paiements progressifs = capital.
   *
   * Formule : L = capital / Σ(g^k × PVA(intervalleProgression, tauxMensuel, k×intervalleProgression))
   * où g = 1 + tauxProgression, PVA = valeur actuelle d'une annuité
   */
  calculerLoyerProgressifInitial(capital: number, tauxAnnuel: number, dureeMois: number, tauxProgression: number, intervalleProgression: number): number {
    if (capital <= 0 || dureeMois <= 0) return 0;

    const tauxMensuel = tauxAnnuel / 12;
    const g = 1 + tauxProgression; // facteur de progression (ex: 1.10)
    const nbPaliers = Math.ceil(dureeMois / intervalleProgression);

    let facteurTotal = 0;

    for (let k = 0; k < nbPaliers; k++) {
      const debutPalier = k * intervalleProgression;
      const moisPalier = Math.min(intervalleProgression, dureeMois - debutPalier);

      if (moisPalier <= 0) break;

      // PVA = (1 - (1+r)^-n) / r pour une annuité de 1 pendant n mois au taux r
      let pva: number;
      if (tauxMensuel > 0) {
        pva = (1 - Math.pow(1 + tauxMensuel, -moisPalier)) / tauxMensuel;
      } else {
        pva = moisPalier;
      }

      // Facteur d'actualisation pour ramener au temps 0
      const facteurActualisation = tauxMensuel > 0 ? Math.pow(1 + tauxMensuel, -debutPalier) : 1;

      facteurTotal += Math.pow(g, k) * pva * facteurActualisation;
    }

    return facteurTotal > 0 ? Math.round(capital / facteurTotal / 1000) * 1000 : 0;
  }

  /**
   * Génère le tableau d'amortissement progressif
   */
  genererTableauProgressif(capital: number, tauxAnnuel: number, dureeMois: number, tauxProgression: number, intervalleProgression: number) {
    this.tableauProgressif = [];
    if (capital <= 0 || dureeMois <= 0) return;

    const tauxMensuel = tauxAnnuel / 12;
    const g = 1 + tauxProgression;
    const loyerInitial = this.calculerLoyerProgressifInitial(capital, tauxAnnuel, dureeMois, tauxProgression, intervalleProgression);
    this.loyerProgressifInitial = loyerInitial;

    // Pré-calculer le loyer de chaque palier avec MROUND(1000) comme dans l'Excel
    // Chaque palier = MROUND(loyerPalierPrécédent × g, 1000)
    const nbPaliers = Math.ceil(dureeMois / intervalleProgression);
    const loyerParPalier: number[] = [loyerInitial];
    for (let k = 1; k < nbPaliers; k++) {
      loyerParPalier.push(Math.round(loyerParPalier[k - 1] * g / 1000) * 1000);
    }

    let prevCumulAmort = 0;
    let amort0 = 0;
    let cumulProgressif = 0;

    for (let periode = 1; periode <= dureeMois; periode++) {
      const i = periode - 1;
      const palier = Math.floor(i / intervalleProgression);
      const loyerProgressif = loyerParPalier[palier];

      // G: amortissement = loyer - intérêts (intérêts sur capital - cumul amort précédent)
      const interets = (capital - prevCumulAmort) * tauxMensuel;
      const amortissement = loyerProgressif - interets;

      // H: cumul amortissement (reproduit le calcul Excel — H18 = G17 + H17)
      let cumulAmort: number;
      if (i === 0) {
        cumulAmort = amortissement;
        amort0 = amortissement;
      } else if (i === 1) {
        cumulAmort = amort0 + prevCumulAmort;
      } else {
        cumulAmort = amortissement + prevCumulAmort;
      }

      cumulProgressif += loyerProgressif;
      const capitalRestant = capital - cumulAmort;
      prevCumulAmort = cumulAmort;

      this.tableauProgressif.push({
        periode: periode,
        loyerProgressif: loyerProgressif,
        cumulProgressif: Math.round(cumulProgressif),
        amortissementProgressif: Math.round(amortissement),
        cumulAmortissement: Math.round(cumulAmort),
        capitalRestantProgressif: Math.max(0, Math.round(capitalRestant))
      });
    }
  }

  newForm() {
    this.form = this.formBuild.group({
      uuid: [null],
      id: [null],
      numero: [null],
      customer: [null, [Validators.required]],
      date: [null, [Validators.required]],
      datelivraison: [null],
      dateprevision: [null],
      dateentree: [null],
      delai: [null],
      caution: [null],
      delailimite: [null],
      motif: [{ value: 'PROPRIETAIRE'}, [Validators.required]],
      charge: [null],
      folderUuid: [null],
      datelimite: [0],
      taux: [0],
      isSigned: [false, [Validators.required]],
      modalite: ['COMPTANT', [Validators.required]],
      typeContrat: ['LOCATION_ACCESSION_OPT_ECO'],
      montantFrais: [0, [Validators.required, Validators.pattern(ValidatorsEnums.decimal), Validators.min(0)]],
      montantCharge: [0, [Validators.pattern(ValidatorsEnums.decimal), Validators.min(0)]],
      nbrMois: [0, [Validators.pattern(ValidatorsEnums.number), Validators.min(0)]],
      typeEcheancier: ['CONSTANT'],
      tauxProgression: [0.10],
      intervalleProgression: [60],
      montant: [0, [Validators.required, Validators.pattern(ValidatorsEnums.decimal)]],
      montantHt: [0, [Validators.required, Validators.pattern(ValidatorsEnums.decimal)]],
      montantTva: [0, [Validators.required, Validators.pattern(ValidatorsEnums.decimal)]],
      remise: [0, [Validators.required, Validators.pattern(ValidatorsEnums.decimal)]],
      montantBien: [0, [Validators.required, Validators.pattern(ValidatorsEnums.decimal)]],
      isConjoint: [false],
      dateDebutFacturation: [null],
      montantAvance: [0, [Validators.required, Validators.pattern(ValidatorsEnums.decimal), Validators.min(0)]],
      optionHouses: this.formBuild.array(this.itemHouse()),
      optionFolders: this.formBuild.array(this.itemOption()),
      echeanceFolders: this.formBuild.array([]),
      avanceFolders: this.formBuild.array([]),
      folders: this.formBuild.array([]),
    });
  }

  editForm() {
    if (this.edit) {
      const data = { ...this.folderService.getFolder() }
      this.setCustomerUuid(data.customer?.uuid);
      this.customerSelected = {
        photoSrc: data.customer?.photoSrc,
        title: data.customer?.searchableTitle,
        detail: data.customer?.searchableDetail
      };
      data.charge = data?.charge?.uuid;
      data.customer = data?.customer?.uuid;
      data.date = DateHelperService.fromJsonDate(data?.date);
      data.dateDebutFacturation = DateHelperService.fromJsonDate(data?.dateDebutFacturation);
      data?.options?.forEach((item) => {
        this.options.push(
          this.formBuild.group({
            uuid: [item.uuid],
            id: [item.id],
            libelle: [item.libelle, [Validators.required]],
            prix: [item.prix, [Validators.required, Validators.pattern(ValidatorsEnums.decimal), Validators.min(0)]],
            qte: [item.qte, [Validators.required, Validators.pattern(ValidatorsEnums.number), Validators.min(1)]],
            tva: [item.tva, [Validators.required, Validators.pattern(ValidatorsEnums.decimal), Validators.min(0)]],
            remise: [item.remise, [Validators.required, Validators.pattern(ValidatorsEnums.decimal), Validators.min(0)]],
            total: [item.total, [Validators.required, Validators.pattern(ValidatorsEnums.decimal), Validators.min(0)]],
          }));
      });
      data?.houses?.forEach((item) => {
        var house = null;
        var label = null;
        if (data.motif === 'PROPRIETAIRE') {
          house = item.house?.uuid
          label = item.house?.searchableDetail
        } else if (data.motif === 'LOT') {
          house = item.lot?.uuid
          label = item.lot?.searchableDetail
        } else if (data.motif === 'MAISON') {
          house = item.home?.uuid
          label = item.home?.searchableDetail
        }
        this.optionHouses.push(
          this.formBuild.group({
            uuid: [item.uuid],
            id: [item.id],
            house: [house, [Validators.required]],
            label: [{ value: label, disabled: true }],
            prix: [item.prix, [Validators.required, Validators.pattern(ValidatorsEnums.decimal), Validators.min(0)]],
            qte: [item.qte, [Validators.required, Validators.pattern(ValidatorsEnums.number), Validators.min(1)]],
            tva: [item.tva, [Validators.required, Validators.pattern(ValidatorsEnums.decimal), Validators.min(0)]],
            remise: [item.remise, [Validators.required, Validators.pattern(ValidatorsEnums.decimal), Validators.min(0)]],
            total: [item.total, [Validators.required, Validators.pattern(ValidatorsEnums.decimal), Validators.min(0)]],
          })
        );
      });
      data?.echeances?.forEach((item: any, index: number) => {
        this.echeanceFolders.push(
          this.formBuild.group({
            uuid: [item?.uuid],
            id: [item?.id],
            date: [DateHelperService.fromJsonDate(item?.date), [Validators.required]],
            mensualiteBase: [item?.mensualiteBase || 0, [Validators.pattern(ValidatorsEnums.decimal), Validators.min(0)]],
            charge: [item?.charge || 0, [Validators.pattern(ValidatorsEnums.decimal), Validators.min(0)]],
            montant: [item?.montant, [Validators.required, Validators.pattern(ValidatorsEnums.decimal), Validators.min(0)]],
            description: [item?.description],
            capitalRestant: [{ value: item?.capitalRestant || 0, disabled: true }], // ✅ Ajout du champ capitalRestant
          })
        );
      });
      data?.advances?.forEach((item: any) => {
        this.avanceFolders.push(
          this.formBuild.group({
            uuid: [item?.uuid],
            id: [item?.id],
            libelle: [{ value: item?.libelle, disabled: true }, [Validators.required]],
            prc: [{ value: item?.prc, disabled: false }, [Validators.required]],
            montant: [{ value: item?.montant, disabled: true }, [Validators.required, Validators.pattern(ValidatorsEnums.decimal), Validators.min(0)]],
          })
        );
      });
      this.form.patchValue(data)
      this.f.folderUuid.setValue(data?.folder?.uuid)
      this.onCalcul()

      console.log(data);

      // Si dossier INVALIDE sans maisons, ajouter une ligne vide pour permettre la re-sélection
      console.log('=== DEBUG EDIT FOLDER ===');
      console.log('editLocked:', this.editLocked);
      console.log('folder.etat:', this.folder?.etat);
      console.log('houses:', data.houses);
      console.log('optionHouses.length:', this.optionHouses.length);
      if (!this.editLocked && (!data.houses || data.houses.length === 0)) {
        this.addOptionHouse();
        console.log('optionHouse ajoutée, length:', this.optionHouses.length);
      }

      // ✅ Recalculer le tableau d'amortissement si en mode échéancier
      if (data.modalite === 'ECHEANCE' && data.nbrMois > 0) {
        const capital = data.houses?.[0]?.home?.baseActualisation || 0
        this.genererTableauAmortissement(capital, data.taux, data.nbrMois);
      }
    }
  }

  itemOption(): FormGroup[] {
    const arr: any[] = [];
    if (!this.edit) {
      for (let i = 1; i <= 3; i++) {
        var label = ""
        if (i === 1) { var label = "Frais de cession" } else if (i === 2) {
          var label = "Frais de dossier technique"
        } else if (i === 3) { var label = "Frais de compulsoire" }
        arr.push(
          this.formBuild.group({
            uuid: [null],
            id: [null],
            libelle: [{ value: label, disabled: true }, [Validators.required]],
            prix: [0, [Validators.required, Validators.pattern(ValidatorsEnums.decimal), Validators.min(0)]],
            qte: [1, [Validators.required, Validators.pattern(ValidatorsEnums.number), Validators.min(1)]],
            tva: [0, [Validators.pattern(ValidatorsEnums.decimal), Validators.min(0)]],
            remise: [0, [Validators.pattern(ValidatorsEnums.decimal), Validators.min(0)]],
            total: [0, [Validators.pattern(ValidatorsEnums.decimal), Validators.min(0)]]
          })
        )
      }
    }
    return arr
  }

  itemHouse(): FormGroup[] {
    const arr: any[] = [];
    if (!this.edit) {
      arr.push(
        this.formBuild.group({
          uuid: [null],
          id: [null],
          house: [null, [Validators.required]],
          label: [{ value: null, disabled: true }],
          prix: [0, [Validators.required, Validators.pattern(ValidatorsEnums.decimal), Validators.min(0)]],
          qte: [1, [Validators.required, Validators.pattern(ValidatorsEnums.number), Validators.min(1)]],
          tva: [0, [Validators.pattern(ValidatorsEnums.decimal), Validators.min(0)]],
          remise: [0, [Validators.pattern(ValidatorsEnums.decimal), Validators.min(0)]],
          total: [0, [Validators.pattern(ValidatorsEnums.decimal), Validators.min(0)]]
        })
      )
    }
    return arr
  }

  setCustomerUuid(uuid) {
    if (uuid) {
      this.f.customer.setValue(uuid);
      this.loadCustomer(uuid)
    } else { this.customer = null }
  }

  setHouseUuid(uuid, row) {
    if (uuid) {
      row.controls.house.setValue(uuid);
      this.houseService.getSingle(uuid).subscribe(res => {
        if (res?.uuid) {
          if (res?.mandate) {
            row.controls.prix.setValue(res?.mandate?.valeur);
            this.onChangeTotalOption(row)
          } else {
            row.controls.house.setValue(null);
            row.controls.prix.setValue(0);
            this.toast("Ce bien ne fait l'objet d'aucun mandat de gestion le concernant.", "Bien sans mandat", "warning")
          }
        }
      }, error => { })
    } else {
      row.controls.prix.setValue(0);
      this.onChangeTotalOption(row)
    }
  }

  setLotUuid(uuid, row) {
    if (uuid) {
      row.controls.house.setValue(uuid);
      this.lotService.getSingle(uuid).subscribe((res: any) => {
        if (res) {
          console.log(res)
          row.controls.prix.setValue(res?.montant);
          this.onChangeTotalOption(row)
        }
      }, error => { })
    } else {
      row.controls.prix.setValue(0);
      this.onChangeTotalOption(row)
    }
  }

  setHomeUuid(item, row) {
    console.log(item, row)
    if (item) {
      var uuid = item.uuid;
      row.controls.house.setValue(uuid);
      this.homeService.getSingle(uuid).subscribe((res: any) => {
        if (res) {
          console.log(res)
          this.f.nbrMois.setValue(res.config[0]['mois']);
          const tauxValue = res.config[0]['taux'];
          this.f.taux.setValue(tauxValue);

          const chargeMensuelle = res.config[0]['charge'] || 0;
          this.f.montantCharge.setValue(chargeMensuelle);

          const modalite = this.f.modalite.value;
          let montantAPrendre;

          if (modalite === 'ECHEANCE' || modalite === 'ECHEANCE_ANNUEL') {
            montantAPrendre = (res?.baseActualisation != null && res?.baseActualisation > 0) ? res.baseActualisation : (res?.montant || 0);
            this.toast(
              `Mode ${modalite === 'ECHEANCE_ANNUEL' ? 'échéancier annuel' : 'échéancier'}: utilisation de baseActualisation (${montantAPrendre.toLocaleString()} F CFA) + Charges: ${chargeMensuelle.toLocaleString()} F CFA/mois`,
              'Information modalité',
              'info'
            );
          } else {
            montantAPrendre = res?.montant || 0;
            if (modalite !== 'COMPTANT') {
              this.toast(
                `Mode ${modalite}: utilisation du montant standard (${montantAPrendre.toLocaleString()} F CFA)`,
                'Information modalité',
                'info'
              );
            }
          }

          row.controls.prix.setValue(montantAPrendre);
          this.onChangeTotalOption(row);

          if (this.f.modalite.value === 'ECHEANCE') {
            this.addEcheanceFolder();
          }
          if (this.f.modalite.value === 'ECHEANCE_ANNUEL') {
            this.addEcheanceAnnuelFolder();
          }
        }
      }, error => { })
    } else {
      row.controls.prix.setValue(0);
      this.f.nbrMois.setValue(0);
      this.f.taux.setValue(0);
      this.f.montantCharge.setValue(0);
      this.onChangeTotalOption(row);
    }
  }

  loadCustomer(uuid) {
    if (uuid) {
      this.customerService.getSingle(uuid).subscribe(res => {
        this.customer = res;
      }, error => { })
    }
  }

  onCalcul() {
    let totalOptionRemise = 0;
    let totalOptionHT = 0;
    let totalOptionTVA = 0;
    let totalOptionTTC = 0;
    let totalBien = 0;
    this.options.controls.forEach(elem => {
      totalOptionRemise += elem.value.remise >= 0 ? elem.value.remise : 0;
      totalOptionHT += (elem.value.qte >= 1 && (elem.value.remise <= (elem.value.prix * elem.value.qte))) ? (elem.value.prix * elem.value.qte) - elem.value.remise : 0;
      totalOptionTVA += elem.value.tva >= 0 ? ((elem.value.prix * elem.value.qte) - elem.value.remise) * (elem.value.tva / 100) : 0;
      totalOptionTTC += elem.value.total;
    });
    this.optionHouses.controls.forEach(elem => {
      totalOptionRemise += elem.value.remise >= 0 ? elem.value.remise : 0;
      totalOptionHT += (elem.value.qte >= 1 && (elem.value.remise <= (elem.value.prix * elem.value.qte))) ? (elem.value.prix * elem.value.qte) - elem.value.remise : 0;
      totalOptionTVA += elem.value.tva >= 0 ? ((elem.value.prix * elem.value.qte) - elem.value.remise) * (elem.value.tva / 100) : 0;
      totalOptionTTC += elem.value.total;
      totalBien += elem.value.total;
    });
    this.totalRemise = totalOptionRemise > 0 ? totalOptionRemise : 0;
    this.totalHt = totalOptionHT >= 0 ? totalOptionHT : 0;
    this.totalTva = totalOptionTVA >= 0 ? totalOptionTVA : 0;

    if (this.f.modalite.value === 'ECHEANCE' && this.f.nbrMois.value > 0) {
      const capitalAAmortir = totalOptionTTC - this.f.montantAvance.value;
      const tauxAnnuel = this.f.taux.value || 0;
      const tauxFinal = tauxAnnuel > 1 ? tauxAnnuel / 100 : tauxAnnuel;

      if (capitalAAmortir > 0 && tauxFinal >= 0) {
        const isProgressif = this.f.typeEcheancier.value === 'PROGRESSIF';
        if (isProgressif) {
          const tauxProg = this.f.tauxProgression.value || 0.10;
          const intervalleProg = this.f.intervalleProgression.value || 60;
          const loyerInitial = this.calculerLoyerProgressifInitial(capitalAAmortir, tauxFinal, this.f.nbrMois.value, tauxProg, intervalleProg);
          const g = 1 + tauxProg;
          const nbPaliers = Math.ceil(this.f.nbrMois.value / intervalleProg);
          let totalProgressif = 0;
          let loyerPalier = loyerInitial;
          for (let k = 0; k < nbPaliers; k++) {
            const moisPalier = Math.min(intervalleProg, this.f.nbrMois.value - k * intervalleProg);
            totalProgressif += loyerPalier * moisPalier;
            loyerPalier = Math.round(loyerPalier * g / 1000) * 1000;
          }
          this.totalTtc = totalProgressif;
        } else {
          const mensualiteBase = this.calculerMensualiteAmortissement(capitalAAmortir, tauxFinal, this.f.nbrMois.value);
          this.totalTtc = mensualiteBase * this.f.nbrMois.value;
        }
      } else {
        this.totalTtc = totalOptionTTC;
      }
    } else if (this.f.modalite.value === 'ECHEANCE_ANNUEL' && this.f.nbrMois.value > 0) {
      const capitalAAmortir = totalOptionTTC - this.f.montantAvance.value;
      const tauxAnnuel = this.f.taux.value || 0;
      const tauxFinal = tauxAnnuel > 1 ? tauxAnnuel / 100 : tauxAnnuel;
      if (capitalAAmortir > 0) {
        const nbrAnnees = this.f.nbrMois.value;
        let annuite;
        if (tauxFinal === 0) {
          annuite = capitalAAmortir / nbrAnnees;
        } else {
          annuite = capitalAAmortir * tauxFinal / (1 - Math.pow(1 + tauxFinal, -nbrAnnees));
        }
        annuite = Math.round(annuite / 1000) * 1000;
        this.totalTtc = annuite * nbrAnnees;
      } else {
        this.totalTtc = totalOptionTTC;
      }
    } else {
      this.totalTtc = totalOptionTTC;
    }

    this.f.montant.setValue(totalOptionTTC);
    this.f.montantHt.setValue(this.totalHt);
    this.f.montantTva.setValue(this.totalTva);
    this.f.remise.setValue(this.totalRemise);
    this.f.montantBien.setValue(totalBien);
  }

  onChangeTotal() {
    if (this.f.montantAvance.value > this.f.montant.value) {
      this.toast(
        "Le montant d'avance ne peut être supérieur au montant total.",
        'Attention !',
        'warning'
      );
      this.f.montantAvance.setValue(0);
      return;
    }

    this.onCalcul();

    if (this.f.modalite.value === 'ECHEANCE' && this.f.nbrMois.value > 0) {
      this.addEcheanceFolder();
      this.avanceFolders.controls.length = 0;
    }

    if (this.f.modalite.value === 'ECHEANCE_ANNUEL' && this.f.nbrMois.value > 0) {
      this.addEcheanceAnnuelFolder();
      this.avanceFolders.controls.length = 0;
    }

    if (this.f.modalite.value === 'AVANCEMENT') {
      this.f.nbrMois.setValue(0);
      this.echeanceFolders.controls.length = 0;
      this.addAvanceFolder();
    }
  }

  onChangeTotalOption(row) {
    var remise = row.value.remise >= 0 ? row.value.remise : 0;
    var totalHT = (row.value.qte >= 1 && (row.value.remise <= (row.value.prix * row.value.qte))) ? (row.value.prix * row.value.qte) - remise : 0;
    var totalTva = row.value.tva >= 0 ? totalHT * (row.value.tva / 100) : 0;
    var total = totalHT + totalTva;
    if (row.value.prix >= 0 && total >= 0) {
      row.controls.total.setValue(total);
      this.onChangeTotal()
    } else {
      row.controls.total.setValue(0);
      this.onChangeTotal()
    }
  }

  onChangeModaliteAvecRecalcul() {
    this.onChangeModalite();

    if (this.f.motif.value === 'MAISON') {
      this.optionHouses.controls.forEach((row: any) => {
        const houseUuid = row.controls.house.value;
        if (houseUuid) {
          this.homeService.getSingle(houseUuid).subscribe((res: any) => {
            if (res) {
              const modalite = this.f.modalite.value;
              let montantAPrendre;
              const chargeMensuelle = res.config[0]['charge'] || 0;

              if (modalite === 'ECHEANCE' || modalite === 'ECHEANCE_ANNUEL') {
                montantAPrendre = (res?.baseActualisation != null && res?.baseActualisation > 0) ? res.baseActualisation : (res?.montant || 0);
                this.f.montantCharge.setValue(chargeMensuelle);
                this.toast(
                  `Changement vers mode ${modalite === 'ECHEANCE_ANNUEL' ? 'échéancier annuel' : 'échéancier'}: nouveau prix ${montantAPrendre.toLocaleString()} F CFA + Charges: ${chargeMensuelle.toLocaleString()} F CFA/mois`,
                  'Recalcul modalité',
                  'info'
                );
              } else if (modalite === 'COMPTANT') {
                montantAPrendre = res?.montant || 0;
                // Conserver la charge mensuelle depuis la config du bien pour COMPTANT
                this.f.montantCharge.setValue(chargeMensuelle);
              } else {
                montantAPrendre = res?.montant || 0;
                this.f.montantCharge.setValue(0);
                this.toast(
                  `Changement vers mode ${modalite}: nouveau prix ${montantAPrendre.toLocaleString()} F CFA (montant standard)`,
                  'Recalcul modalité',
                  'info'
                );
              }

              row.controls.prix.setValue(montantAPrendre);
              this.onChangeTotalOption(row);
            }
          });
        }
      });
    }
  }

  onChangeModalite() {
    if (this.form.value.modalite === 'COMPTANT') {
      this.f.nbrMois.setValue(0)
      this.echeanceFolders.controls.length = 0;
      this.avanceFolders.controls.length = 0;
    }
    if (this.form.value.modalite === 'ECHEANCE_ANNUEL') {
      this.f.nbrMois.setValue(5);
      this.f.taux.setValue(0);
      this.f.typeEcheancier.setValue('ANNUEL');
      this.avanceFolders.controls.length = 0;
    }
    this.onChangeTotal()
  }

  onChangeMotif(event: any) {
    const selectedValue = event.target.value;
    if (selectedValue == "MAISON") {
      this.promotions = [];
      this.sousPromotions = [];
      this.homes = [];
      this.promotionService.getListLight().subscribe((res) => {
        this.promotions = res || [];
      }, (error) => {
        this.promotions = [];
      })
    }
  }

  onChangePromotion(event: any) {
    const selectedValue = event.uuid;

    if (!selectedValue) {
      this.sousPromotions = [];
      this.homes = [];
      return;
    }

    // Sous-promotions côté client
    const promo = this.promotions.find(p => p.uuid === selectedValue);
    this.sousPromotions = promo?.sousPromotions || [];

    // Homes via endpoint léger
    this.homeService.getListLight(selectedValue).subscribe(
      (res) => { this.homes = res || []; },
      (error) => { this.homes = []; }
    );
  }

  onChangeSousPromotion(event: any) {
    const selectedValue = event;

    if (!selectedValue) {
      this.homes = [];
      return;
    }

    this.homes = [];
    this.homeService.getListLight(selectedValue.uuid).subscribe(
      (res) => { this.homes = res || []; },
      (error) => { this.homes = []; }
    );
  }

  onSelectType($event) {
    const value = $event.target.value;
    this.f.typeContrat.setValue(value);
    console.log("data", value);
  }

  onChangeTauxOuDuree() {
    if (this.f.modalite.value === 'ECHEANCE' && this.f.nbrMois.value > 0 && this.f.taux.value > 0) {
      this.addEcheanceFolder();
    }
  }

  onSubmit() {
    this.f.montant.setValue(this.totalTtc)
    this.submit = true;
    if (!this.form.invalid) {
      const folder = this.form.getRawValue();
      // Convertir ECHEANCE_ANNUEL en ECHEANCE + typeEcheancier ANNUEL pour le backend
      if (folder.modalite === 'ECHEANCE_ANNUEL') {
        folder.modalite = 'ECHEANCE';
        folder.typeEcheancier = 'ANNUEL';
      }
      this.folderService.add(folder).subscribe(res => {
        if (res?.status === 'success') {
          this.modal.close('ferme');
          if (this.form.value.uuid) {
            this.emitter.emit({ action: 'FOLDER_UPDATED', payload: res?.data });
          } else {
            this.emitter.emit({ action: 'FOLDER_ADD', payload: res?.data });
          }
        }
      }, error => {
      });
    } else {
      this.toast('Votre formualire n\'est pas valide.', 'Attention !', 'warning');
      return;
    }
  }

  onConfirme() {
    Swal.fire({
      title: '',
      text: 'Confirmez-vous l\'enregistrement ?',
      icon: 'warning',
      showCancelButton: true,
      showCloseButton: true,
      confirmButtonText: 'Confirmer <i class="fas fa-check"></i>',
      cancelButtonText: 'Annuler <i class="feather icon-x-circle"></i>',
      confirmButtonColor: '#1bc943',
      reverseButtons: true
    }).then((willDelete) => {
      if (!willDelete.dismiss) {
        this.onSubmit();
      }
    });
  }

  addOptionHouse() {
    return this.optionHouses.push(
      this.formBuild.group({
        uuid: [null],
        id: [null],
        house: [null, [Validators.required]],
        label: [{ value: null, disabled: true }],
        prix: [0, [Validators.required, Validators.pattern(ValidatorsEnums.decimal), Validators.min(0)]],
        qte: [1, [Validators.required, Validators.pattern(ValidatorsEnums.number), Validators.min(1)]],
        tva: [0, [Validators.required, Validators.pattern(ValidatorsEnums.decimal), Validators.min(0)]],
        remise: [0, [Validators.required, Validators.pattern(ValidatorsEnums.decimal), Validators.min(0)]],
        total: [0, [Validators.required, Validators.pattern(ValidatorsEnums.decimal), Validators.min(0)]]
      })
    );
  }

  addOption() {
    return this.options.push(
      this.formBuild.group({
        uuid: [null],
        id: [null],
        libelle: [null, [Validators.required]],
        prix: [0, [Validators.required, Validators.pattern(ValidatorsEnums.decimal), Validators.min(0)]],
        qte: [1, [Validators.required, Validators.pattern(ValidatorsEnums.number), Validators.min(1)]],
        tva: [0, [Validators.required, Validators.pattern(ValidatorsEnums.decimal), Validators.min(0)]],
        remise: [0, [Validators.required, Validators.pattern(ValidatorsEnums.decimal), Validators.min(0)]],
        total: [0, [Validators.required, Validators.pattern(ValidatorsEnums.decimal), Validators.min(0)]],
      })
    );
  }

  addEcheanceFolder() {
    this.echeanceFolders.controls.length = 0;

    const nbr = this.f.nbrMois.value || 0;
    const tauxAnnuel = this.f.taux.value || 0;
    const montantTotal = this.f.montant.value || 0;
    const apportInitial = this.f.montantAvance.value || 0;
    const capitalAAmortir = montantTotal - apportInitial;

    const chargeMensuelle = this.f.montantCharge.value || 0;

    if (nbr <= 0 || capitalAAmortir <= 0) {
      return this.echeanceFolders;
    }

    const tauxFinal = tauxAnnuel > 1 ? tauxAnnuel / 100 : tauxAnnuel;

    const mensualiteBase = this.calculerMensualiteAmortissement(capitalAAmortir, tauxFinal, nbr);

    this.genererTableauAmortissement(capitalAAmortir, tauxFinal, nbr);

    // Générer le tableau progressif si le type d'échéancier est PROGRESSIF
    const isProgressif = this.f.typeEcheancier.value === 'PROGRESSIF';
    if (isProgressif) {
      const tauxProg = this.f.tauxProgression.value || 0.10;
      const intervalleProg = this.f.intervalleProgression.value || 60;
      this.genererTableauProgressif(capitalAAmortir, tauxFinal, nbr, tauxProg, intervalleProg);
      this.mensualiteConstante = this.loyerProgressifInitial + chargeMensuelle;
    } else {
      this.mensualiteConstante = mensualiteBase + chargeMensuelle;
    }

    for (let i = 0; i < nbr; i++) {
      const options = { year: 'numeric', month: 'long' };

      const dateReference = this.f.dateDebutFacturation.value
        ? new Date(this.f.dateDebutFacturation.value)
        : (this.f.dateentree.value ? new Date(this.f.dateentree.value)
        : (this.f.date.value ? new Date(this.f.date.value) : new Date()));

      const dateEcheance = this.f.dateDebutFacturation.value
        ? DateHelperService.addMonths(dateReference, i)
        : DateHelperService.addMonths(dateReference, i + 1);

      const label = `Échéance du mois de ${dateEcheance.toLocaleDateString('fr-FR', options)}`;

      // Mensualité : si progressif, utiliser le loyer progressif comme mensualité de base
      const mensualitePeriode = isProgressif ? (this.tableauProgressif[i]?.loyerProgressif || mensualiteBase) : mensualiteBase;
      const montantPeriode = mensualitePeriode + chargeMensuelle;

      this.echeanceFolders.controls.push(
        this.formBuild.group({
          uuid: [null],
          id: [null],
          date: [dateEcheance.toISOString().slice(0, 10), [Validators.required]],
          mensualiteBase: [mensualitePeriode, [Validators.pattern(ValidatorsEnums.decimal), Validators.min(0)]],
          charge: [chargeMensuelle, [Validators.pattern(ValidatorsEnums.decimal), Validators.min(0)]],
          montant: [montantPeriode, [Validators.required, Validators.pattern(ValidatorsEnums.decimal), Validators.min(0)]],
          description: [label],
          periode: [i + 1],
          capitalRestant: [isProgressif ? (this.tableauProgressif[i]?.capitalRestantProgressif || 0) : (this.tableauAmortissement[i]?.capitalRestant || 0)],
          cumulPaiements: [isProgressif ? (this.tableauProgressif[i]?.cumulProgressif || 0) : (this.tableauAmortissement[i]?.cumulPaiements || 0)],
          loyerProgressif: [isProgressif ? (this.tableauProgressif[i]?.loyerProgressif || 0) : null],
          cumulProgressif: [isProgressif ? (this.tableauProgressif[i]?.cumulProgressif || 0) : null],
          amortissementProgressif: [isProgressif ? (this.tableauProgressif[i]?.amortissementProgressif || 0) : null],
          cumulAmortissement: [isProgressif ? (this.tableauProgressif[i]?.cumulAmortissement || 0) : null],
          capitalRestantProgressif: [isProgressif ? (this.tableauProgressif[i]?.capitalRestantProgressif || 0) : null],
        })
      );
    }

    // Mettre à jour totalTtc avec le cumul progressif si applicable
    if (isProgressif && this.tableauProgressif.length > 0) {
      this.totalTtc = this.tableauProgressif[this.tableauProgressif.length - 1].cumulProgressif;
    }

    const dateRef = this.f.dateDebutFacturation.value ? 'date de début de facturation' :
      (this.f.dateentree.value ? 'date d\'entrée' : 'date d\'ouverture');
    if (isProgressif) {
      this.toast(
        `Échéancier progressif généré. Loyer initial : ${this.loyerProgressifInitial.toLocaleString()} F CFA (+${((this.f.tauxProgression.value || 0.10) * 100)}% / ${((this.f.intervalleProgression.value || 60) / 12)} ans)`,
        'Calcul avec progression',
        'info'
      );
    } else {
      this.toast(
        `Échéancier généré à partir de la ${dateRef}. Mensualité de base : ${mensualiteBase.toLocaleString()} F CFA + Charges : ${chargeMensuelle.toLocaleString()} F CFA = Total : ${this.mensualiteConstante.toLocaleString()} F CFA`,
        'Calcul d\'amortissement avec charges',
        'info'
      );
    }

    return this.echeanceFolders;
  }

  addEcheanceAnnuelFolder() {
    this.echeanceFolders.controls.length = 0;

    const nbrAnnees = this.f.nbrMois.value || 0;
    const tauxAnnuel = this.f.taux.value || 0;
    const montantTotal = this.f.montant.value || 0;
    const apportInitial = this.f.montantAvance.value || 0;
    const capitalAAmortir = montantTotal - apportInitial;

    if (nbrAnnees <= 0 || capitalAAmortir <= 0) {
      return this.echeanceFolders;
    }

    const tauxFinal = tauxAnnuel > 1 ? tauxAnnuel / 100 : tauxAnnuel;

    let annuite;
    if (tauxFinal === 0) {
      annuite = capitalAAmortir / nbrAnnees;
    } else {
      annuite = capitalAAmortir * tauxFinal / (1 - Math.pow(1 + tauxFinal, -nbrAnnees));
    }
    annuite = Math.round(annuite / 1000) * 1000;

    const dateReference = this.f.dateDebutFacturation.value
      ? new Date(this.f.dateDebutFacturation.value)
      : (this.f.dateentree.value ? new Date(this.f.dateentree.value)
      : (this.f.date.value ? new Date(this.f.date.value) : new Date()));

    let capitalRestant = capitalAAmortir;
    let cumulPaiements = 0;

    for (let i = 0; i < nbrAnnees; i++) {
      const dateEcheance = new Date(dateReference);
      dateEcheance.setFullYear(dateEcheance.getFullYear() + i);

      const interets = capitalRestant * tauxFinal;
      let capitalRembourse = annuite - interets;
      let annuiteFinale = annuite;

      // Dernière échéance : ajuster pour absorber les arrondis
      if (i === nbrAnnees - 1) {
        annuiteFinale = capitalRestant + interets;
        capitalRembourse = capitalRestant;
      }

      capitalRestant -= capitalRembourse;
      cumulPaiements += annuiteFinale;

      const label = `Échéance annuelle ${i + 1}/${nbrAnnees}`;

      this.echeanceFolders.controls.push(
        this.formBuild.group({
          uuid: [null],
          id: [null],
          date: [dateEcheance.toISOString().slice(0, 10), [Validators.required]],
          mensualiteBase: [Math.round(annuiteFinale)],
          charge: [0],
          montant: [Math.round(annuiteFinale), [Validators.required]],
          description: [label],
          periode: [i + 1],
          capitalRestant: [Math.max(0, Math.round(capitalRestant))],
          cumulPaiements: [Math.round(cumulPaiements)],
        })
      );
    }

    this.mensualiteConstante = annuite;

    this.toast(
      `Échéancier annuel généré : ${nbrAnnees} ans, annuité ${annuite.toLocaleString()} F CFA, capital à amortir ${capitalAAmortir.toLocaleString()} F CFA`,
      'Calcul échéancier annuel',
      'info'
    );

    return this.echeanceFolders;
  }

  addAvanceFolder() {
    this.avanceFolders.controls.length = 0;
    if (this.f.montant.value > 0) {
      this.advanceRow.forEach(item => {
        var montant = Math.round(((this.f.montant.value - this.f.montantAvance.value) * item?.prc) / 100)
        this.avanceFolders.controls.push(
          this.formBuild.group({
            uuid: [null],
            id: [null],
            libelle: [{ value: item?.label, disabled: true }, [Validators.required]],
            prc: [{ value: item?.prc, disabled: false }, [Validators.required]],
            montant: [{ value: montant, disabled: true }, [Validators.required, Validators.pattern(ValidatorsEnums.decimal), Validators.min(0)]],
          })
        );
      });
    }
    return this.avanceFolders;
  }

  setPourcentage(row) {
    var prc = 0
    this.avanceFolders.controls.forEach((item: any) => { prc = prc + item.get('prc').value });
    if (prc > 100) {
      this.toast(
        "Le pourcentage total de l'état d'avancement ne peut excéder les 100%.",
        'Attention !',
        'warning'
      );
      row.controls.prc.setValue(0);
    }
    var montant = Math.round(((this.f.montant.value - this.f.montantAvance.value) * row?.value?.prc) / 100)
    row.controls.montant.setValue(montant);
  }

  onDeleteOptions(i) {
    this.options.removeAt(i)
    return this.onChangeTotal();
  }

  onDeleteOptionHouse(i) {
    this.optionHouses.removeAt(i)
    return this.onChangeTotal();
  }

  afficherDetailAmortissement() {
    if (this.tableauAmortissement.length === 0) {
      this.toast('Aucun tableau d\'amortissement généré', 'Information', 'info');
      return;
    }

    const tauxAnnuel = this.f.taux.value;
    const tauxFinal = tauxAnnuel > 1 ? tauxAnnuel / 100 : tauxAnnuel;
    const capitalAAmortir = this.f.montant.value - this.f.montantAvance.value;
    const debit = capitalAAmortir / this.f.nbrMois.value;
    const chargeMensuelle = this.f.montantCharge.value || 0;

    console.log('=== DÉTAIL DU TABLEAU D\'AMORTISSEMENT ===');
    console.log(`Taux annuel: ${(tauxFinal * 100)}%`);
    console.log(`Capital à amortir: ${capitalAAmortir.toLocaleString()} F CFA`);
    console.log(`Durée: ${this.f.nbrMois.value} mois`);
    console.log(`Débit mensuel (capital): ${debit.toLocaleString()} F CFA`);
    console.log(`Charges mensuelles: ${chargeMensuelle.toLocaleString()} F CFA`);
    console.log(`Mensualité de base: ${(this.mensualiteConstante - chargeMensuelle).toLocaleString()} F CFA`);
    console.log(`Mensualité totale: ${this.mensualiteConstante.toLocaleString()} F CFA`);

    this.toast(
      `Mensualité base: ${(this.mensualiteConstante - chargeMensuelle).toLocaleString()} F CFA + Charges: ${chargeMensuelle.toLocaleString()} F CFA = Total: ${this.mensualiteConstante.toLocaleString()} F CFA`,
      'Détail du calcul avec charges',
      'info'
    );
  }

  toast(msg, title, type): void {
    if (type === 'info') {
      this.toastr.info(msg, title);
    } else if (type === 'success') {
      this.toastr.success(msg, title);
    } else if (type === 'warning') {
      this.toastr.warning(msg, title);
    } else if (type === 'error') {
      this.toastr.error(msg, title);
    }
  }

  files(data) {
    if (data && data !== null) {
      data.forEach(item => {
        this.folderf.push(
          this.formBuild.group({
            uuid: [item?.uuid, [Validators.required]],
            name: [item?.name],
            path: [item?.path]
          })
        );
      });
    }
  }

  upload(files): void {
    for (const file of files) {
      this.uploadService.upload(file);
    }
  }

  setParam(property, value): void {
    if (value) {
      if (this.form.value.hasOwnProperty(property)) {
        Object.assign(this.form.value, { [property]: value });
      }
      if (this.form.controls.hasOwnProperty(property)) {
        this.form.controls[property].setValue(value);
      }
    }
  }

  @HostListener('document:keydown', ['$event']) onKeydownHandler(event: KeyboardEvent) {
    if (event.keyCode === this.ESCAPE_KEYCODE) {
      this.onClose()
    }
  }

  onClose() {
    if (!this.edit && this.form.value.folderUuid) {
      var data = { uuid: this.form.value.folderUuid, path: 'dossier' }
      this.uploadService.getDelete(data).subscribe((res: any) => {
        if (res) {
          if (res?.status === 'success') {
            this.form.reset()
            this.modal.close('ferme');
          }
        }
        return res
      });
    } else {
      this.form.reset()
      this.modal.close('ferme');
    }
  }

  onReset() {
    if (this.form.value.folderUuid) {
      this.toast('Impossible de de vider le formulaire lorsque un upload a été éffectué', 'Une erreur a été rencontrée', 'warning');
    } else {
      this.form.reset()
    }
  }

  get f() { return this.form.controls; }
  get options() { return this.form.get('optionFolders') as FormArray; }
  get optionHouses() { return this.form.get('optionHouses') as FormArray; }
  get echeanceFolders() { return this.form.get('echeanceFolders') as FormArray; }
  get avanceFolders() { return this.form.get('avanceFolders') as FormArray; }
  get folderf() { return this.form.get('folders') as FormArray; }
}